import { Component, OnInit, Input, NgModule } from '@angular/core'
import { RegistrationService } from '@service/registration.service'

import { MatDialog } from '@angular/material/dialog';
import { IntroductionDialogComponent } from '@modal/introduction-dialog/introduction-dialog.component';
import { SharedModule } from 'src/app/shared.module';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ScrollService } from '@service/scroll.service';
import { StateService } from '@service/state.service';
import { Angulartics2Facebook } from 'angulartics2';

@Component({
  selector: 'app-registration-confirm',
  templateUrl: './registration-confirm.component.html',
  styleUrls: ['./registration-confirm.component.scss'],
})
export class RegistrationConfirmComponent implements OnInit {
  @Input() public stateParams: any

  public loading: boolean = false

  constructor(
    private registrationService: RegistrationService,
    private MatDialog: MatDialog,
    private ActivatedRoute: ActivatedRoute,
    public ScrollService: ScrollService,
    private StateService: StateService,
    private Angulartics2Facebook: Angulartics2Facebook
  ) { }

  public ngOnInit(): void {

    let user_id = parseInt(this.ActivatedRoute.snapshot.paramMap.get('user_id'))
    let confirmation_code = this.ActivatedRoute.snapshot.paramMap.get('confirmation_code')

    this.loading = true
    this.registrationService
      .verifyEmail(user_id, confirmation_code)
      .then(() => {
        this.loading = false

        this.StateService.goto('/profile/about')

        // facebook track
        this.Angulartics2Facebook.eventTrack('CompleteRegistration', {})

        const config = {}
        const dialogRef = this.MatDialog.open(IntroductionDialogComponent, {
          data: config,
          disableClose: true,
          width: '100vw',
          maxWidth: '100vw',
          height: '100vh',
          panelClass: IntroductionDialogComponent.cssClass
        })
          .afterClosed().subscribe(() => {
            this.ScrollService.scrollToTop()
          })

      })
      .finally(() => {
        this.loading = false
      })
  }
}

@NgModule({
  declarations: [
    RegistrationConfirmComponent
  ],
  imports: [
    SharedModule,

    RouterModule.forChild([
      {
        path: "",
        component: RegistrationConfirmComponent
      },
    ]),
  ],
  exports: [
    RegistrationConfirmComponent,

    SharedModule,
  ]
})
export class RegistrationConfirmModule { }